import { path } from './paths';

export const navLinks = [
  {
    id: 0,
    label: 'home-text',
    url: path.LANDING
  },
  {
    id: 1,
    label: 'about-us',
    url: path.ABOUT
  },
  {
    id: 2,
    label: 'marketplace-text',
    url: path.MARKET
  },
  {
    id: 3,
    label: 'contact-text',
    url: path.CONTACT
  }
];
export const blogNavLinks = [
  {
    id: 0,
    label: 'all-articles',
    url: path.BLOG
  },
  {
    id: 1,
    label: 'international-trade-text',
    url: path.INTERNATIONALTRADE
  },
  {
    id: 2,
    label: 'storage-text',
    url: path.STORAGE
  },
  {
    id: 3,
    label: 'cultivation-text',
    url: path.CULTIVATION
  }
];
export const MarketplaceNavLinks = [
  {
    id: 0,
    label: 'All',
    url: path.MARKET
  },
  {
    id: 1,
    label: 'Herbs & Spices',
    url: path.HERBSANDSPICES
  },
  {
    id: 2,
    label: 'Fruits',
    url: path.FRUITS
  },
  {
    id: 3,
    label: 'Vegetables',
    url: path.VEGETABLES
  },
  {
    id: 3,
    label: 'Nuts',
    url: path.NUTS
  },
  {
    id: 3,
    label: 'Grains',
    url: path.GRAINS
  },
  {
    id: 3,
    label: 'Legumes',
    url: path.LEGUMES
  },
  {
    id: 3,
    label: 'Tubers',
    url: path.TUBERS
  },
  {
    id: 3,
    label: 'Beverages',
    url: path.BEVERAGES
  }
];
